import { render, staticRenderFns } from "./ListAffiliatesTab.vue?vue&type=template&id=3ec7de3f&scoped=true&"
import script from "./ListAffiliatesTab.vue?vue&type=script&lang=js&"
export * from "./ListAffiliatesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec7de3f",
  null
  
)

export default component.exports